import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/EcommerceDashboardBasic.css';

interface BasicSalesData {
  totalSales: number;
  totalOrders: number;
  totalProducts: number;
  totalCustomers: number;
}

const EcommerceDashboardBasic: React.FC = () => {
  const [salesData, setSalesData] = useState<BasicSalesData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setSalesData({
        totalSales: 125450,
        totalOrders: 1248,
        totalProducts: 156,
        totalCustomers: 892
      });
      setLoading(false);
    }, 1000);
  }, []);

  if (loading) {
    return (
      <div className="ecommerce-basic-loading">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="ecommerce-dashboard-basic">
      <div className="header-basic-ecommerce">
        <Link to="/" className="back-button-basic-ecommerce">← Back</Link>
        <h1>E-commerce Dashboard</h1>
        <span className="version-badge-basic-ecommerce">Synoppy 1.0</span>
      </div>

      {salesData && (
        <div className="metrics-grid-basic">
          <div className="metric-card-basic">
            <h3>Total Sales</h3>
            <div className="metric-value-basic">${salesData.totalSales.toLocaleString()}</div>
          </div>
          
          <div className="metric-card-basic">
            <h3>Total Orders</h3>
            <div className="metric-value-basic">{salesData.totalOrders}</div>
          </div>
          
          <div className="metric-card-basic">
            <h3>Products</h3>
            <div className="metric-value-basic">{salesData.totalProducts}</div>
          </div>
          
          <div className="metric-card-basic">
            <h3>Customers</h3>
            <div className="metric-value-basic">{salesData.totalCustomers}</div>
          </div>
        </div>
      )}

      <div className="chart-section-basic">
        <div className="chart-placeholder-basic">
          <h3>Sales Chart</h3>
          <div className="basic-chart">
            <div className="chart-bar" style={{height: '60%'}}></div>
            <div className="chart-bar" style={{height: '80%'}}></div>
            <div className="chart-bar" style={{height: '45%'}}></div>
            <div className="chart-bar" style={{height: '90%'}}></div>
            <div className="chart-bar" style={{height: '75%'}}></div>
          </div>
        </div>
      </div>

      <div className="upgrade-section-basic">
        <Link to="?version=1.5" className="upgrade-link-basic">
          Try Synoppy 1.5 Advanced Version →
        </Link>
      </div>
    </div>
  );
};

export default EcommerceDashboardBasic;